import React, { memo, useCallback, useState } from 'react';
import { BubbleMenu as BaseBubbleMenu, Editor } from '@tiptap/react';
import { useTranslation } from 'react-i18next';

import { isRowGripSelected } from '../../extensions/table/utils';
import Dropdown from '@common/components/dropdown/dropdown';

interface MenuProps {
  editor: Editor | null;
  appendTo?: React.RefObject<any>
}

export const TableRowMenu = memo(({ editor, appendTo }: MenuProps): JSX.Element => {
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  const shouldShow = useCallback(
    ({ view, state, from }) => {
      if (!state || !from || !editor) {
        setShow(false);
        return false;
      }
      const isSelected = isRowGripSelected({ editor, view, state, from });
      setShow(isSelected);
      return isSelected;
    },
    [editor],
  );

  const onAddRowBefore = useCallback(() => {
    editor?.chain().focus().addRowBefore().run();
  }, [editor]);

  const onAddRowAfter = useCallback(() => {
    editor?.chain().focus().addRowAfter().run();
  }, [editor]);

  const onDeleteRow = useCallback(() => {
    editor?.chain().focus().deleteRow().run();
  }, [editor]);

  return (
    <BaseBubbleMenu
      editor={editor}
      pluginKey="tableRowMenu"
      updateDelay={0}
      tippyOptions={{
        zIndex: 4,
        placement: 'left',
        appendTo: () => {
          return appendTo?.current;
        },
      }}
      shouldShow={shouldShow}
    >
      {show && (
        <div>
          <Dropdown open>
            <Dropdown.Item icon="upload" onClick={onAddRowBefore}>
              <span>{t('knowledge_base:add_row_before')}</span>
            </Dropdown.Item>
            <Dropdown.Item icon="download" onClick={onAddRowAfter}>
              <span>{t('knowledge_base:add_row_after')}</span>
            </Dropdown.Item>
            <Dropdown.Item icon="delete" onClick={onDeleteRow} danger>
              <span>{t('knowledge_base:delete_row')}</span>
            </Dropdown.Item>
          </Dropdown>
        </div>
      )}
    </BaseBubbleMenu>
  );
});
